.select-group {
  &.label-to-the-left {
    display: grid;
    grid-template-columns: auto 250px;
    grid-gap: 17px;
    align-items: center;

    .select-label {
      font-size: 14px;
      font-weight: 600;
      color: var(--gray_dark1);
    }
  }

  .select-label {
    &.with-clear {
      display: flex;
      justify-content: space-between;

      .select-label-clear-btn {
        cursor: pointer;
        color: var(--color_primary_500);
      }
    }

    font-size: 12px;
    font-weight: 400;
    color: var(--gray_dark2);
  }

  .filter {
    margin-left: 0;
  }

  .select-icon-group {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid var(--gray_light1);
    border-radius: 4px;
    background: var(--base_color2);

    &:focus-within {
      border-color: var(--color_primary_500);
    }

    .filter {
      width: 100%;

      &>div {
        border: none;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        min-width: 220px;
      }
    }

    .select-icon {
      fill: var(--gray_dark1);
    }
  }
}

.reactSelect-sublabel {
  color: var(--gray);
  font-size: 12px;

  &.selected {
    color: var(--base_color2);
  }
}

.option-disabled {
  &.filter-post {
    cursor: default;
    display: block;
    font-size: inherit;
    padding: 8px 12px;
    width: 100%;
    box-sizing: border-box;
    background-image: url(../../assets/images/svg/locker.svg);
    background-repeat: no-repeat;
    background-position: 355px center;
  }

  &.tooltipped-n {
    &::after {
      bottom: 17%;
    }

    &::before {
      border-top-color: transparent;
    }
  }
}

.select-icon-group {
  transform: translateZ(0);

  .container-option {
    .popover-language-content {
      user-select: auto;
      display: none;
    }

    &:hover {
      .popover-language-content {
        user-select: auto;

        .text {
          margin-bottom: 36px;
        }

        .email {
          user-select: auto;
          font-size: 14px;
          line-height: 20px;
          color: var(--gray_dark2);
          display: block;
        }

        .image {
          display: block;
          width: 64px;
          height: 64px;
          margin: 10px auto;
        }

        box-shadow: 8px 10px 12px rgba(0, 0, 0, 0.15);
        border: 1px solid var(--gray_light2);
        border-radius: 4px;
        display: block;
        position: fixed;
        padding: 10px 20px 28px;
        left: 102%;
        top: 104%;
        background: #fff;
        width: 230px;
      }
    }
  }
}